import styled from '@emotion/styled';

const Heading = styled.span`
  font-size: ${({ theme }) => theme.sizes.caption};
  line-height: 28px;
`;

export default Heading;
